export const PgCampaignCookie = "pg.campaign";